import ApiService from '@/core/services/api.service';
import decounce from 'debounce';

const productSearchMixin = {
  mounted() {
    this.fetchProduct();
  },
  data() {
    return {
      searchProduct: '',
      filteredOptionsProduct: [],
      optionsProduct: [
        {
          data: [],
        },
      ],
    };
  },
  methods: {
    fetchProduct() {
      this.optionsProduct[0].data = [];
      ApiService.setHeader();
      ApiService.get(
        `productSearch/withMerchant?searchProduct=${this.searchProduct}&storeId=&includeParent=true`,
      ).then(({ data }) => {
        const products = data.data;
        products.map((element) => {
          this.optionsProduct[0].data.push(element);
        });
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
      });
    },
    onInputChangeProduct(text) {
      if (!text) {
        text = '';
      }
      this.searchProduct = text;
      this.queryParams.productId = null;
      this.debounceInput();
    },
    debounceInput: decounce(function () {
      this.fetchProduct();
    }, 300),
    onSelectedProduct(option) {
      this.queryParams.productId = option.item.productId;
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.productName;
    },
  },
};
export default productSearchMixin;
